var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearBoxIcon = function SvgGearBoxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.735 0a2.264 2.264 0 0 0-2.264 2.26c0 1.064.742 1.959 1.737 2.196v1.039c0 .828-.676 1.501-1.508 1.501H9.566v-2.54a2.264 2.264 0 0 0 1.738-2.197 2.264 2.264 0 0 0-4.53 0c0 1.065.743 1.96 1.738 2.197v2.54h-5.72v-2.54A2.264 2.264 0 0 0 4.529 2.26 2.264 2.264 0 0 0 0 2.26c0 1.065.742 1.96 1.737 2.197v5.783A2.264 2.264 0 0 0 0 12.436a2.264 2.264 0 0 0 4.53 0c0-1.064-.743-1.96-1.738-2.197V8.05h5.72v2.188a2.264 2.264 0 0 0-1.738 2.197 2.264 2.264 0 0 0 4.53 0c0-1.064-.742-1.96-1.738-2.197V8.05H13.7a2.56 2.56 0 0 0 2.563-2.556V4.456A2.264 2.264 0 0 0 18 2.26 2.264 2.264 0 0 0 15.735 0"
  })));
};
export default SvgGearBoxIcon;